package dev.lingvo.shared.screenshots.frames

import dev.lingvo.shared.screenshots.geom.Rect
import dev.lingvo.shared.screenshots.render.Path
import dev.lingvo.shared.screenshots.render.PathBuilder
import dev.lingvo.shared.screenshots.render.Paths
import kotlin.math.min

/** Uses one repeatable cubic per corner so nested body, bezel and capture masks share the same silhouette. */
fun roundedRect(r: Rect, radius: Double, smoothing: Double): Path {
    require(listOf(r.x, r.y, r.w, r.h, radius, smoothing).all { it.isFinite() }) { "Rounded rectangle requires finite geometry" }
    require(r.w >= 0 && r.h >= 0 && radius >= 0 && smoothing in 0.0..1.0) { "Invalid rounded rectangle dimensions" }
    val reach = min(radius * (1 + smoothing), min(r.w, r.h) / 2)
    val control = reach * (1 - Paths.KAPPA) * (1 - .35 * smoothing)
    return PathBuilder()
        .moveTo(r.x + reach, r.y)
        .lineTo(r.right - reach, r.y)
        .cubicTo(r.right - control, r.y, r.right, r.y + control, r.right, r.y + reach)
        .lineTo(r.right, r.bottom - reach)
        .cubicTo(r.right, r.bottom - control, r.right - control, r.bottom, r.right - reach, r.bottom)
        .lineTo(r.x + reach, r.bottom)
        .cubicTo(r.x + control, r.bottom, r.x, r.bottom - control, r.x, r.bottom - reach)
        .lineTo(r.x, r.y + reach)
        .cubicTo(r.x, r.y + control, r.x + control, r.y, r.x + reach, r.y)
        .close().build()
}
